module.exports = __webpack_public_path__ + "static/021-12c83fa42c98049ec46f0fb87000702d.jpg";